import {
  flightInfoGetFlightStatuses,
  flightInfoGetFlightStatusesSuccess,
} from '@actions/flight-info.action';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { TripService } from '@services/api-clients/trip.service';
import { Observable, of } from 'rxjs';
import { mergeMap, switchMap } from 'rxjs/operators';

@Injectable()
export class FlightInfoEffect {
  searchFlightStatuses$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(flightInfoGetFlightStatuses),
      mergeMap(({ request }) => {
        return this.tripService.searchFlightStatuses(request).pipe(
          switchMap(({ data: results }) => {
            return of(
              flightInfoGetFlightStatusesSuccess({
                results,
              }),
            );
          }),
        );
      }),
    );
  });

  constructor(
    private actions$: Actions,
    private tripService: TripService,
  ) {}
}
